import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { MatchingProperty } from 'app/event/models/matching-property';
import { MatchingPropertyService } from 'app/shared/matching-property/matching-property.service';
import { Page } from 'app/shared/models/page';
import { Constants } from 'app/shared/constants';

@Component({
  selector: 'pioneer-matching-property-list',
  templateUrl: './matching-property-list.component.html'
})
export class MatchingPropertyListComponent implements OnInit {

  @Input()
  properties: Page<MatchingProperty>;

  @Input()
  currentPage: number;

  @Output()
  public sortPage: EventEmitter< {field: string, direction: string} > = new EventEmitter< {field: string, direction: string} >();

  constructor(
    private environment: EnvironmentConfiguration,
    private matchingPropertyService: MatchingPropertyService,
    private router: Router) {
  }

  ngOnInit() {
  }

  get propertyCount(): number {
    return this.properties.totalElements;
  }

  get propertyCountForTranslate(): Object {
    return {
      propertyCount: this.propertyCount
    };
  }

  isNotProvided(vendorId: string): boolean {
    let searchPattern = new RegExp('^' + Constants.NOT_PROVIDED_VENDOR_ID_PREFIX);
    return searchPattern.test(vendorId);
  }

  selectProperty(property: MatchingProperty): void {
    this.matchingPropertyService.setSelectedProperty(property);
    this.matchingPropertyService.setSelectedPage(this.currentPage);
    this.router.navigate([ '/events/matching/property/candidates' ], {
    });
  }

  sortList(field: string, direction: string) {
    this.sortPage.emit( { field: field, direction: direction } );
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/matching-property/matching-property-list/matching-property-list.component.ts